import { useEffect, useState } from "react"
import { FileIndex } from "../../lib/backend/fileUpload"
import { Fragment } from 'react'
import { useNavigate } from 'react-router-dom'
import { Dialog, Transition } from '@headlessui/react'
import TemplateFileUpload from "../../components/TemplateFileUpload"
import { GetSession } from "../../lib/backend/auth"
import { Navigate } from "react-router-dom"

export default function DashboardPage() {

	const [tempFilesMissing, setTempFilesMissing] = useState(false)
	const [initialLoading, setInitialLoading] = useState(true)
	const [files, setFiles] = useState([])
	const [showModal, setShowModal] = useState(false)

	const navigate = useNavigate();

	useEffect(() => {
		getFilesData()
	}, [])

	async function getFilesData() {
		const response = await GetSession()
		if (!response.ok) {
			navigate("/login")
		} else {
			const body = await response.json()
			if (body.temp === "Y") {
				const responseIndex = await FileIndex()
				const bodyIndex = await responseIndex.json()
				// console.log({ body })
				setFiles(bodyIndex)
				bodyIndex.forEach((file: any) => {
					if (file.filename === "None") {
						setShowModal(true)
					}
				})
				setInitialLoading(false)
			} else {
				setInitialLoading(false)
			}
		}
	}

	return (
		<>
			<div className="text-2xl font-semibold mb-4">
				Dashboard
			</div>
			<div className="w-full" hidden={!initialLoading}>
				<div className="flex w-full justify-center">
					<svg aria-hidden="true" className="w-12 h-12 mr-4 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
						<path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
					</svg>
				</div>
			</div>

			<Transition.Root show={showModal} as={Fragment}>
				<Dialog as="div" className="relative z-10" onClose={setShowModal}>
					<Transition.Child
						as={Fragment}
						enter="ease-out duration-300"
						enterFrom="opacity-0"
						enterTo="opacity-100"
						leave="ease-in duration-200"
						leaveFrom="opacity-100"
						leaveTo="opacity-0"
					>
						<div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
					</Transition.Child>

					<div className="fixed inset-0 z-10 overflow-y-auto">
						<div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
							<Transition.Child
								as={Fragment}
								enter="ease-out duration-300"
								enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
								enterTo="opacity-100 translate-y-0 sm:scale-100"
								leave="ease-in duration-200"
								leaveFrom="opacity-100 translate-y-0 sm:scale-100"
								leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
							>
								<Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-2 pt-2 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
									<div className="w-full">
										{/* <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"> */}
										{/* <ExclamationTriangleIcon className="h-6 w-6 text-red-600" aria-hidden="true" /> */}
										{/* </div> */}
										<div className="text-center sm:ml-2 sm:mt-0 sm:text-left">
											<Dialog.Title as="h3" className="text-2xl font-semibold leading-6 text-gray-900">
												Required Files
											</Dialog.Title>
											<div className="w-full">

												<div className="mt-6 mb-4 text-gray-600 w-full">
													<p>
														Here is the list of required files.
													</p>
													<p>
														Once you upload all required files, your account will progress.
													</p>
												</div>

												<div className="grid grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-1">

													{files && files.length > 0 && files.map((item: any, index: number) => {
														return <div key={index} className="sm:col-span-2 border-b border-gray-900/10 pb-8 mt-2">
															<div className="block font-medium leading-6 text-gray-900 text-xl underline">
																{item.temp_type_name}
															</div>
															<TemplateFileUpload tempKey={item.temp_type_id} documentNumber={item.document_type_id} existingFile={item.filename} GetFilesData={getFilesData} userId={null} />
														</div>
													})}

												</div>
											</div>
											<div className="mt-8 text-gray-600">
												Alternatively, you can upload the files at the bottom of the Account page
											</div>
										</div>
									</div>
									<div className="mt-8 sm:mt-4 w-full text-right">
										<button
											type="button"
											className="mt-3 inline-flex w-full justify-right rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:ml-3 sm:mt-0 sm:w-auto"
											onClick={() => setShowModal(false)}
										>
											Close
										</button>
									</div>
								</Dialog.Panel>
							</Transition.Child>
						</div>
					</div>
				</Dialog>
			</Transition.Root>
		</>
	)
}